import img from '../../Assets/LearningPath/digital-marketing.png'
const DigitalMarketinginput = [
    {
        key : 0,
        img : img,
        title : "Search Engine Optimization",
        // video : "https://firebasestorage.googleapis.com/v0/b/form-b6d08.appspot.com/o/Data%20Analysis%20And%20Visualization%20In%20Power%20Bi%20-%20Training%20Session%2003%20For%20Batch%2004.mp4?alt=media&token=42ac35cf-a0da-4d6c-ac2e-0f12b5b3e696"
         duration: " 4",
        videos: "20",
        btn : "Watch Videos"
    },
    {
        key : 1,
        img : img,
        title : "Social Media Marketing",
         duration: " 4",
        videos: "20",
        btn : "Watch Videos",
    },
    {
        key : 2,
        img : img,
        title :"Affiliate Marketing",
         duration: " 4",
        videos: "20",
        btn : "Watch Videos",
    },
    {
        key : 3,
        img : img,
        title : "Google Ads",
         duration: " 4",
        videos: "20",
        btn : "Watch Videos",
    },
    
]
export default DigitalMarketinginput;